import { LinearProgress, Typography } from '@material-ui/core';
import React from 'react';

import { isHolidayPeriod } from '~/src/dash/utils/date';
import { BoxCenter } from '~/src/dash/views/box-align-center-view';

export interface ILoadingProps {
  active: boolean;
  containerStyles?: React.CSSProperties;
  innerStyles?: React.CSSProperties;
  textStyles?: React.CSSProperties;
  text?: string;
}

export function LoadingView({
  active,
  containerStyles,
  innerStyles,
  textStyles,
  text,
}: ILoadingProps) {
  return (
    <div>
      <BoxCenter
        containerStyles={{
          transform: 'all 1s',
          opacity: active ? 1 : 0,
          ...containerStyles,
        }}
        innerStyles={innerStyles}
      >
        <Typography variant='h4' style={{ marginBottom: '1rem', ...textStyles }}>
          {text || 'Loading'}
        </Typography>
        <div style={{ padding: '2rem 3rem ' }}>
          <LinearProgress />
        </div>
      </BoxCenter>
      {/* #HOLIDAYTHEME - Snowflakes display during holiday period (Dec 1 - Jan 3) */}
      {isHolidayPeriod() && (
        <div className='snowflakes' aria-hidden='true'>
          <div className='snowflake-css'>
            <div className='inner'>❅</div>
          </div>
          <div className='snowflake-css'>
            <div className='inner'>❅</div>
          </div>
          <div className='snowflake-css'>
            <div className='inner'>❅</div>
          </div>
          <div className='snowflake-css'>
            <div className='inner'>❅</div>
          </div>
          <div className='snowflake-css'>
            <div className='inner'>❅</div>
          </div>
          <div className='snowflake-css'>
            <div className='inner'>❅</div>
          </div>
          <div className='snowflake-css'>
            <div className='inner'>❅</div>
          </div>
          <div className='snowflake-css'>
            <div className='inner'>❅</div>
          </div>
          <div className='snowflake-css'>
            <div className='inner'>❅</div>
          </div>
          <div className='snowflake-css'>
            <div className='inner'>❅</div>
          </div>
          <div className='snowflake-css'>
            <div className='inner'>❅</div>
          </div>
          <div className='snowflake-css'>
            <div className='inner'>❅</div>
          </div>
        </div>
      )}
    </div>
  );
}
